exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-title {\r\n  text-align: center;\r\n}\r\n.mat-button {\r\n  min-width: 30px;\r\n  padding: 0px;\r\n}\r\n.suggestion-value {\r\n  position: relative;\r\n}\r\n\r\n.suggestion-list {\r\n  position: absolute;\r\n  background: white;\r\n  z-index: 1000;\r\n  margin: 10px;\r\n  padding: 5px;\r\n  border: solid 1px black;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/payload-form/payload-form.component.css
// module id = ../../../../../src/app/components/utils/item-type-manager/forms/payload-form/payload-form.component.css
// module chunks = main